<div class="bg-black full-page">
  <div class="maintenance-container text-center">
    <div class="d-flex align-items-center justify-content-center logo-container">
      <div class="logo-wrapper">
        <img src="assets/images/login-registration/logo_rewards.svg" />
      </div>
    </div>
    <div class="bg-white content-maintenance">
      <div class="text-primary icon material-symbols-outlined">engineering</div>
      <h5 class="text-primary text-uppercase mb-0">{{ 'maintenance.page.title' | translate }}</h5>
      <p class="font-size-14 maintenance-description mb-0">{{ 'maintenance.page.details' | translate }}</p>
    </div>
  </div>
</div>
